export default __webpack_public_path__ + "static/media/LakeEola.180a8713.jpeg";